import Skeleton from "../skeleton/Skeleton";
import Thumbnail from "../skeleton/Thumbnail";
import Text from "../skeleton/Text";

const ProductLoader = () => {
  return (
    <div className="product-details product-details-loading">
      <div className="product-gallery-card">
        <Skeleton>
          <Thumbnail height="560px" />
        </Skeleton>
      </div>

      <div className="product-detail-card">
        <Skeleton>
          <Text />
          <Text mt="14px" />
          <Text mt="14px" />
          <Thumbnail height="80px" />
          <Text mt="14px" />
          <Thumbnail height="60px" />
        </Skeleton>
      </div>
    </div>
  );
};

export default ProductLoader;
